export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function isValidPhone(phone: string): boolean {
  // Accepts: +1234567890, 123-456-7890, (123) 456-7890, 1234567890
  return /^\+?[0-9\s\-()]{7,}$/.test(phone);
}